function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bx-cookie",
  transform: "translate(-3 -3.065)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11629",
  "data-name": "Path 11629",
  d: "M52.166,25.7a2.524,2.524,0,0,0-2.142-.432,7.371,7.371,0,0,1-1.866.271,7.516,7.516,0,0,1-7.535-7.367c.012-.085.04-.341.043-.426a2.5,2.5,0,0,0-3.146-2.524,7.432,7.432,0,0,1-1.907.283,7.535,7.535,0,0,1-7.526-7.526,7.219,7.219,0,0,1,.249-1.8,2.509,2.509,0,0,0-2.676-3.1A25.086,25.086,0,1,0,53.175,28.044c0-.124-.008-.244-.018-.4a2.519,2.519,0,0,0-.992-1.947ZM28.087,48.113a20.073,20.073,0,0,1-5-39.513A12.559,12.559,0,0,0,35.614,20.517l.254,0A12.56,12.56,0,0,0,48,30.549,20.1,20.1,0,0,1,28.087,48.113Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11630",
  "data-name": "Path 11630",
  d: "M24.026,18.763A3.763,3.763,0,1,1,20.263,15a3.763,3.763,0,0,1,3.763,3.763Z",
  transform: "translate(9.079 8.026)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11631",
  "data-name": "Path 11631",
  d: "M18.026,14.263A3.763,3.763,0,1,1,14.263,10.5,3.763,3.763,0,0,1,18.026,14.263Z",
  transform: "translate(5.044 5)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11632",
  "data-name": "Path 11632",
  d: "M16.526,20.263A3.763,3.763,0,1,1,12.763,16.5,3.763,3.763,0,0,1,16.526,20.263Z",
  transform: "translate(4.035 9.035)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11633",
  "data-name": "Path 11633",
  d: "M28.526,24.763A3.763,3.763,0,1,1,24.763,21,3.763,3.763,0,0,1,28.526,24.763Z",
  transform: "translate(12.105 12.061)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11635",
  "data-name": "Path 11635",
  d: "M28.526,24.763A3.763,3.763,0,1,1,24.763,21,3.763,3.763,0,0,1,28.526,24.763Z",
  transform: "translate(29.105 -8.939)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11636",
  "data-name": "Path 11636",
  d: "M26.108,23.554A2.554,2.554,0,1,1,23.554,21,2.554,2.554,0,0,1,26.108,23.554Z",
  transform: "translate(36.523 13.479)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11637",
  "data-name": "Path 11637",
  d: "M25.445,23.222A2.222,2.222,0,1,1,23.222,21,2.222,2.222,0,0,1,25.445,23.222Z",
  transform: "translate(17.646 -14.398)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11634",
  "data-name": "Path 11634",
  d: "M21.026,26.263A3.763,3.763,0,1,1,17.263,22.5,3.763,3.763,0,0,1,21.026,26.263Z",
  transform: "translate(7.061 13.07)",
  fill: "#ac1ede"
}));

var SvgBxCookie = function SvgBxCookie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59.631,
    height: 50.066,
    viewBox: "0 0 59.631 50.066",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxCookie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bx-cookie.582d64c0.svg";
export { ForwardRef as ReactComponent };